import { render } from "./IconArrowAlt.vue?vue&type=template&id=60da11b5"
import script from "./IconArrowAlt.vue?vue&type=script&lang=ts"
export * from "./IconArrowAlt.vue?vue&type=script&lang=ts"
script.render = render

export default script